import React, { useMemo, useState, useEffect } from "react";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import axiosInstance from "../axiosApi";
import { useTranslation } from 'react-i18next';
import {
    MRT_EditActionButtons,
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
//Import Material React Table Translations
import { MRT_Localization_KO } from 'material-react-table/locales/ko';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Checkbox,
    Tooltip,
    FormControlLabel,
    Typography,
    InputLabel,
    useTheme
} from '@mui/material';

import {
    QueryClient,
    QueryClientProvider,
    useMutation,
    useQuery,
    useQueryClient,
} from '@tanstack/react-query';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import TableDatePicker from "./TableDatePicker";
import * as dateFns from "date-fns";

const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
});

function AccessLogReport() {
    const { t } = useTranslation();
    const [validationErrors, setValidationErrors] = useState({});
    const [startDate, setStartDate] = useState(new Date());
    const [rowSelection, setRowSelection] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { currentLocation, setCurrentLocation } = useAppContext();
    setCurrentLocation('/accesslog');

    //call READ hook
    const {
        data: fetchedaccesslog = [],
        isError: isLoadingaccesslogError,
        isFetching: isFetchingaccesslog,
        isLoading: isLoadingaccesslog,
        refetch
    } = useGetAccessLog();

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id', //simple recommended way to define a column
                header: 'id',//optional custom props
                size: 50,
            },
            {
                accessorKey: 'user_email', //simple recommended way to define a column
                header: '접근권한자',//optional custom props
                size: 150,
            },
            {
                accessorKey: 'created_at',
                header: '접속일시',
                size: 150,
                Cell: ({ cell }) => {
                    const val = cell.getValue();
                    if (!val) return '';
                    return dateFns.format(new Date(val), 'yyyy년 MM월 dd일 HH:mm:ss');
                },
            },
            {
                accessorKey: 'path', //simple recommended way to define a column
                header: '접근경로',//optional custom props
                size: 150,
            },
        ],
        [validationErrors],
    );

    const handleExportData = () => {
        const csv = generateCsv(csvConfig)(fetchedaccesslog);
        download(csvConfig)(csv);
    };

    const table = useMaterialReactTable({
        columns,
        data: fetchedaccesslog,
        initialState: {
            density: 'compact',
            pagination: { pageSize: 10, pageIndex: 0 }
        },
        muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                fontWeight: 'bold',
                fontSize: '14px',
                backgroundColor: '#D3EFBD',
            },
        },
        enableRowSelection: false,
        enableMultiRowSelection: false,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button>
            </Box>
        ),
    });
    
    //READ hook (get users from api)
    function useGetAccessLog() {
        return useQuery({
            queryKey: ['accesslog'],
            queryFn: async () => {
                //console.log(dateFns.format(startDate, "yyyy-MM-dd"));
                const response = await axiosInstance.get('/accounts/accesslog/', {
                    params: {
                        s_date: dateFns.format(startDate, "yyyy-MM-dd")
                    }
                });
                console.log(response.data);
                return response.data;
            },
        });
    }

    async function onChangeStartDate(event) {
        setStartDate(startDate => event);
    }

    useEffect(() => {
        refetch();
    }, [startDate]);

    return (
        <Box m="10px">
            <Typography variant="h5" fontWeight="bold" mb="10px">
                관리자접근사실기록조회
            </Typography>
            <Box sx={{ display: 'flex', marginTop: 3 }}>
                <InputLabel>기준일자 : </InputLabel>

                <TableDatePicker
                    wrapperClassName="datepicker"
                    selected={startDate}
                    onChange={onChangeStartDate}
                />
            </Box>
            <Box
                mt="10px"
            >
                <MaterialReactTable table={table} />
            </Box>

        </Box>);
}

export default AccessLogReport;